import clientAPIs from '../components/views/Client/clientAPIs'
const state = {
  clients: [],
  dealNatures: []
}

const actions = {
  /**
   * Get all client lists
   * @param {*} commit
   * @returns
  */
  async getClients ({ commit }) {
    try {
      let resp = await clientAPIs.getAllClients()
      commit('SET_CLIENTS', resp.data)
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Get all deal nature lists (filters optional)
   * @param {*} commit
   * @param {Array} filterIds
   * @returns
  */
  async getDealNatures ({ commit }, filterIds = []) {
    try {
      let resp = await clientAPIs.getAllClientDealNatures(false)
      if (resp && resp.data.success) {
        let dealNatures = resp.data.dealNatures || []
        if (filterIds.length > 0) {
          dealNatures = dealNatures.filter(v => filterIds.includes(v.id))
        }
        commit('SET_DealNatures', dealNatures)
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  }
}

const getters = {
}

/**
 * Need actions to implement
 */
// const actions = {}

const mutations = {
  SET_CLIENTS(state, data) {
    state.clients = data
  },
  SET_DealNatures(state, data) {
    state.dealNatures = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/client.js